module.exports = __webpack_public_path__ + "img/button.469f667e.svg";